<template>
    <div class="relative">
        <CCard>
            <CCardHeader>
                <p>Текст политики обработки персональной информации</p>
            </CCardHeader>
            <CCardBody v-if="model">
                <CTextarea
                    v-model="model.settings.text"
                    :rows="20"
                />
            </CCardBody>

            <CCardFooter>
                <CButton
                    class="ml-auto"
                    color="primary"
                    @click="submit">
                    Сохранить
                </CButton>
            </CCardFooter>
        </CCard>

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
    </div>
</template>

<script>
    import { cilSettings } from '@coreui/icons';

    export default {
        icons: {
            cilSettings
        },

        data: () => ({
            isPending: false,
            model: {
                id: 0,
                page: 'personal_information',
                settings: {
                    text: ''
                }
            }
        }),

        async created() {
            await this.fetchEntity();
        },

        methods: {
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },

            async fetchEntity() {
                try {
                    this.isPending = true
                    const { data } = await this.axios.get('/page-settings/personal_information');
                    if (data && data.settings) {
                        this.model = data;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },

            async submit() {
                try {
                    this.isPending = true
                    const { id, ...data } = this.model;
                    if (id) {
                        await this.axios.put(`/page-settings/${id}`, data)
                    } else {
                        await this.axios.post('/page-settings', data)
                    }
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },
        }
    }
</script>